// extracted by mini-css-extract-plugin
module.exports = {"List":"List_List__3YKbb","ListItem":"List_ListItem__3lYAB"};